export default function findSavedBannerElement(listingType, listingId) {
  return document.getElementById(`saved_banner_${listingType}-${listingId}`);
}
